var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84564 4.22596C-0.612204 7.07457 -0.612204 11.6866 1.82763 14.5352C3.15109 10.9875 5.50989 8.02411 8.4539 6.26068C5.96005 8.70235 4.21345 12.1144 3.60124 15.9856C5.94204 17.269 8.82303 16.7995 10.7587 14.5561C13.8918 10.9249 14.4049 0 14.4049 0C14.4049 0 4.97871 0.594765 1.84564 4.22596Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRoad);
export default __webpack_public_path__ + "static/media/greenRoad.9d981c0a.svg";
export { ForwardRef as ReactComponent };